
import { TDiversCartMaxLevelDetailModel, TDiversCartTotalTipoActivo1Model, TDiversCartTotalTipoActivo1y2Model } from "../types/DiversificacionCarteraTypes"

type TFormatTableDataProps = {
    tipoActivo1: TDiversCartTotalTipoActivo1Model[]
    tipoActivo1y2: TDiversCartTotalTipoActivo1y2Model[]
    maxDetail: TDiversCartMaxLevelDetailModel[]
}

export type TDataActivo1 = {
    nomcontrato: string;
    name: string;
    data: TDiversCartTotalTipoActivo1Model
    children?: TDataActivo1y2[]
}

export type TDataActivo1y2 = {
    name: string;
    name2: string;
    data: TDiversCartTotalTipoActivo1y2Model
    children?: TDataMaxDetail[]
}

export type TDataMaxDetail = {
    name: string;
    name2: string;
    nomInstrum: string;
    data: TDiversCartMaxLevelDetailModel
}

export const FormatTableData = ({ tipoActivo1, tipoActivo1y2, maxDetail }: TFormatTableDataProps) => {
    const dataSend: TDataActivo1[] = [];

    tipoActivo1.forEach(activo1 => {
        const data1: TDataActivo1 = {
            nomcontrato: activo1.nomcontrato,
            name: activo1.tipoActivo1,
            data: activo1,
            children: []
        };

        tipoActivo1y2.forEach(activo2 => {
            if (activo1.tipoActivo1 === activo2.tipoActivo1) {
                const data2: TDataActivo1y2 = {
                    name: activo2.tipoActivo1,
                    name2: activo2.tipoActivo2,
                    data: activo2,
                    children: []
                };

                maxDetail.forEach(maxInfo => {
                    if (activo2.tipoActivo1 === maxInfo.tipoActivo1 && activo2.tipoActivo2 === maxInfo.tipoActivo2) {
                        data2.children?.push({
                            name: maxInfo.tipoActivo1,
                            name2: maxInfo.tipoActivo2,
                            nomInstrum: maxInfo.nomInstrum,
                            data: maxInfo
                        });
                    }
                });

                data1.children?.push(data2);
            }
        });

        dataSend.push(data1);
    });

    return dataSend;
};